import { defineMessages } from 'react-intl';

export default defineMessages({
    policyType: {
        id: 'twia.gateway.views.claims-landing.Policy Type',
        defaultMessage: 'POLICY TYPE',
    },
    account: {
        id: 'twia.gateway.views.claims-landing.Account',
        defaultMessage: 'ACCOUNT',
    },
    mailingAddress: {
        id: 'twia.gateway.views.claims-landing.Mailing Address',
        defaultMessage: 'MAILING ADDRESS',
    },
    primaryLossLocation:{
        id: 'twia.gateway.views.claims-landing.Primary Loss Location',
        defaultMessage: 'PRIMARY LOSS LOCATION',
    },
    claimNumber: {
        id: 'twia.gateway.views.claims-landing.Claim Number',
        defaultMessage: 'CLAIM NUMBER',
    },
    dateOfLoss: {
        id: 'twia.gateway.views.claims-landing.Date of Loss',
        defaultMessage: 'DATE OF LOSS',
    },
    status: {
        id: 'twia.gateway.views.claims-landing.Status',
        defaultMessage: 'STATUS',
    },
    paid: {
        id: 'twia.gateway.views.claims-landing.Paid',
        defaultMessage: 'PAID',
    },
    reportedDate: {
        id: 'twia.gateway.views.claims-landing.Reported Date',
        defaultMessage: 'REPORTED DATE',
    },
    policyNumber: {
        id: 'twia.gateway.views.claims-landing.Policy Number',
        defaultMessage: 'POLICY NUMBER',
    },
    twiaClaimVerbiage:{
       id: "gateway.views.claims-landing.Click on a claim number below to view the claim details, update information, and communicate with the claims team.",
       defaultMessage: "Click on a claim number below to view the claim details, update information, and communicate with the claims team."
    },
    tfpaClaimVerbiage:{
        id: "gateway.views.claims-landing.Click on a claim number below to view the claim's status, update information, and communicate with the claims team.",
        defaultMessage: "Click on a claim number below to view the claim's status, update information, and communicate with the claims team."
    },
    twiaClaimsSearchNotification:{
        id: "gateway.views.claims-landing.Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by account name, claim number, policy number, or primary loss location address.",
        defaultMessage: "Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by account name, claim number, policy number, or primary loss location address."
    },
    tfpaClaimsSearchNotification:{
        id: "gateway.views.claims-landing.Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by account name, claim number, policy number, or mailing address.",
        defaultMessage: "Click on a claim number below to view the claim details, update information, and communicate with the claims team. To find a specific claim, you may search by account name, claim number, policy number, or mailing address."
    },
    toDateGreaterThanFromDate:{
        id: "gateway.views.claims-landing.To Date must be greater than From Date",
        defaultMessage: "\"To Date\" must be greater than \"From Date\""
    },

});
